import React from 'react'
import ButtonBlock from './ButtonBlock'

const VideoBlock = ({ video }) => {
  return (
    <div className="video-block-section">
      <div className="video-content">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="video-player"
        >
          <source src={video.videoUrl.publicURL} type="video/mp4" />
        </video>
        <div className="video-overlay">
          <div className='video-text-wrapper'>
            <ButtonBlock
              text="Book Now"
              link="/book"
              className="video-cta-button"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoBlock